import type { BackendTypes } from '@tf/api';

import { useCurrentUser } from '@/core/hooks';
import type { UserCapabilities } from '@/core/types';

/**
 * Check if the current user has a capability
 * @param capability
 */
export const useCurrentUserCapabilityCheck = (capability: UserCapabilities) => {
	const user = useCurrentUser();
	return (
		user.orgRole === 'admin' ||
		user.listRoleCapabilities.includes(capability as BackendTypes.RoleCapabilityValue)
	);
};
